<template>
  <div class="course">
    <weui-group title="为您安排的课程时间">
      <weui-cell :text="course.date_text" />
      <weui-cell v-show="course.weekdays_text" :text="course.weekdays_text" />
      <weui-cell v-show="course.undetermined" text="开始时间" tips="--:--" />
      <weui-cell v-show="course.undetermined" text="结束时间" tips="--:--" />
      <weui-button-cell v-show="course.undetermined">设定课程具体时间</weui-button-cell>
    </weui-group>
    <weui-group title="为您安排的课程内容">
      <weui-cell :text="course.content || '无'" />
    </weui-group>
    <weui-group v-if="course.comment_publicly" title="教练备注">
      <weui-cell :text="course.comment" />
    </weui-group>
    <weui-group tips="运动时必须穿着运动服和运动鞋，所以请提前10分钟到达健身房，以便做好更衣准备。祝您健身愉快！" />
  </div>
</template>

<script>
import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';

export default {
    props: {
        course: {
            type: Object,
            default() {
                return {
                    date_text: null,
                    weekdays_text: null,
                    undetermined: false,
                    content: null,
                    comment: null,
                    comment_publicly: false,
                };
            },
        },
    },
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/course/View.vue